import { Icon } from '@iconify/react';
import { Box, Button, CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../Base';
import { displayNumber } from '../../consts/helpers';
import CarbonEmissionEffectCard from '../cards/CarbonEmissionEffectCard';
import ResultGaugeChart from '../charts/ResultGaugeChart';
import { ButtonContentWithLoader } from '../inputs/ButtonContentWithLoader';
import Step1Inputs from './Step1Inputs';
import Step2Inputs from './Step2Inputs';

export default function ViewInputs({ isValidInputs, callCalcAPI }) {
    const navigate = useNavigate();
    const footprint = useContext(AppContext).footprintState;
    const setFootprint = useContext(AppContext).setFootprint;
    const [isLoading, setIsLoading] = useState(false);

    const handleUpdateClick = () => {
        setIsLoading(true);
        callCalcAPI().then( data => {
            setFootprint(data?.S2_emissions ? data?.S2_emissions*12 : data?.S1_emissions ? data?.S1_emissions*12 : 0);
		    window.scrollTo(0, 0);
            setIsLoading(false);
        });
    }

    return(
        <Stack spacing={4}>
            <Box>
            <Box className='centered-container' sx={{ borderRadius: 'var(--container-rad)', backgroundColor: 'var(--pri-purple)', p: 2, color: 'white', textAlign: 'center' }}>
                <Typography variant="h6" sx={{ mb: 2 }}>Your Carbon Scorecard</Typography>
                <Typography variant='body2'>
                    Your Annual Carbon Footprint<br/>
                    is estimated to be
                </Typography>
                <Typography variant='h5'>
                    <Icon icon="material-symbols:barefoot" color='var(--pri-green)'/>&nbsp;
                    { isLoading ?
                        <CircularProgress size={20} color='inherit' />
                        :
                        <>{displayNumber(footprint, 3)} tCO<sub>2</sub>e/year</>
                    }
                </Typography>
                <ResultGaugeChart resultValue={footprint} />
            </Box>
            <Box className='centered-container' sx={{ p: 2, fontStyle: 'italic' }}>
            <Typography variant='caption'>
                Note: Your estimated footprint may include contributions from certain lifestyle categories not directly mentioned here, such as health, education, and clothing. These are included to provide a complete estimate of your carbon footprint.
            </Typography>
            </Box>
            <Divider />
            </Box>


            <CarbonEmissionEffectCard />

            <Divider>
                <Typography variant="body1" fontSize={'12px'}>Your Expenditure Information</Typography>
            </Divider>

            <Step1Inputs />
            <Divider />

            <Step2Inputs />
            <Button className={`pill_btn ${(!isValidInputs) ? 'Mui-disabled' : 'pri_btn'}`} disabled={!isValidInputs} onClick={handleUpdateClick}>
                { ButtonContentWithLoader(isLoading, 'Update Footprint') }
            </Button>

            <Button className="pill_btn pri_btn outline_btn" onClick={() => navigate('/')}>Back to homepage</Button>
        </Stack>
    )
}